// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__EqyfZ","head":"Table_head__zGjJJ","col":"Table_col__1GAZN"};